import { render, staticRenderFns } from "./template-modal.vue?vue&type=template&id=a447788a"
import script from "./template-modal.vue?vue&type=script&lang=js"
export * from "./template-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a447788a')) {
      api.createRecord('a447788a', component.options)
    } else {
      api.reload('a447788a', component.options)
    }
    module.hot.accept("./template-modal.vue?vue&type=template&id=a447788a", function () {
      api.rerender('a447788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/template-modal.vue"
export default component.exports